export const firmwareAvailabilitiesLabels = {
  "up-to-date": "Up to Date",
  "update-scheduled": "Auto Update Schedule",
  "update-available": "Update Available",
  "new-firmware-available": "New Firmware Available"
}

export const SERIES_NAME_DISPLAY_MAP = {
  "DXS-1250-12": {
    title: "DXS-1250",
    models: "(12/12P/12S)",
  },
  "DXS-1250-28": {
    title: "DXS-1250",
    models: "(28/28P/28S)",
  },
};